import { Routes } from '@angular/router';

import { AirportComponent } from './airport.component';
import { AuthGuard } from '../authentication/auth-guard.service';
import { AirportEditComponent } from './airport-edit.component';
import { OperationsListComponent } from './Operations-lists/operations-list.component';
import { OperationsAddDataPointComponent } from './Operations-lists/operations-add-data-point.component';
import { OperationsGraphComponent } from './Operations-lists/operations-graphs/operations-graph.component';
import { OperationsGraphDisplayComponent } from './Operations-lists/operations-graphs/operations-graph-display.component';
import { OperationsReforecastContainerComponent } from './operations-lists/operations-reforecasts/operations-reforecast-container.component';
import { RegionalReviewComponent} from './regional-review.component';


export const AirportRoutes: Routes = [
  { path: 'airports', component: AirportComponent, canActivate: [AuthGuard] },
  { path: 'airports/:locId', component:  AirportComponent, canActivate: [AuthGuard] },
  { path: 'airports-edit/:locId', component:  AirportEditComponent, canActivate: [AuthGuard] },
  { path: 'operations-list/:tableName', component:  OperationsListComponent, canActivate: [AuthGuard] },
  { path: 'operations-add-year', component:  OperationsAddDataPointComponent, canActivate: [AuthGuard] },
  { path: 'operations-graph/:tableName', component:  OperationsGraphComponent, canActivate: [AuthGuard] },
  { path: 'operations-graph-display/:tableName', component:  OperationsGraphDisplayComponent, canActivate: [AuthGuard]},
  { path: 'operations-reforcast/:tableName', component:  OperationsReforecastContainerComponent, canActivate: [AuthGuard]},
  { path: 'regional-review', component: RegionalReviewComponent, canActivate: [AuthGuard]},
  { path: 'regional-review/:locId', component: RegionalReviewComponent, canActivate: [AuthGuard]},
];


/** WEBPACK FOOTER **
 ** ./app/airports/airport.routes.ts
 **/